import { DefaultRootState, useSelector } from 'react-redux';
import { WebViewAdapter } from 'services/webViewAdapterService';

export const useWebViewAdapter = (): WebViewAdapter | null => {
    const state = useSelector((state) => state);
    return getWebviewAdapter(state);
};

export const getWebviewAdapter = (state: DefaultRootState) => {
    const webviewAdapter = state.parameters?.webViewAdapter ?? null;

    if (
        webviewAdapter?.send ||
        webviewAdapter?.getCurrentPlatform ||
        webviewAdapter?.subscribe ||
        webviewAdapter?.currentPlatform
    ) {
        return webviewAdapter;
    }

    return null;
};
